import { useAppSelector } from '../../data/store';
import ReactDOM from 'react-dom';
import { sendGAEvent } from '../../../../domain/marketing/gtm-provider';

const $box = document.getElementById('add-items-to-cart-placeholder') as Element;

const AddToCartBtn = () => {
    const allProductsToCartBtnLink = useAppSelector(store => store.allProductsToCartBtnLink);
    if(!$box){
        return (
            <></>
        )
    }

    return ReactDOM.createPortal(
        <>
            {
                !!allProductsToCartBtnLink &&
                <div className="flex waves-box-lg mx-auto px-5 md:px-12 mt-6">
                    <a
                        href={ allProductsToCartBtnLink }
                        className="w-btn w-auto ml-auto mr-auto md:ml-auto md:mr-0"
                        onClick={ () => {
                            sendGAEvent('Click', 'Add all products to cart');
                        }}>Add all products to cart</a>
                </div>
            }
        </>,
        $box
    );
};

export default AddToCartBtn;